export const LOADING_PRIORITY = {
	HIGH: 'preload',
	LOW: 'prefetch',
} as const;
